/**
 * Auth0-specific types for Architeia
 * Extends the shared types with Auth0-specific claims and user data
 */
/**
 * Auth0 custom claims namespace (AINFRA-99): Kora owns kora.id and issues these claims. The same
 * value is `CLAIM_NAMESPACE` in `@architeia/auth-server`, which a frontend cannot import.
 */
export const ARCHITEIA_NAMESPACE = 'https://kora.id/claims/';
/**
 * The namespace used before AINFRA-99. Read only as a fallback for tokens minted before the Auth0
 * Action started emitting both; delete with the fallback once those tokens have expired.
 */
export const LEGACY_ARCHITEIA_NAMESPACE = 'https://architeia.org/';
